import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-[#0A0A0A] text-white/60 font-mono-p text-sm">
        <span className="cursor-blink">initializing prismquery</span>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
